// Added by Jonghyung Lee on 2021-02-16
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import axios from 'axios'

import { getQueryString } from '@/helper/util'
import { GetQueryReturn } from '@/helper/define'
import { NotificationItem, ReqGetNotifications } from '@/helper/define'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const BASE_URL_NOTIFICATIONS = '/v1/mgmt/notifications'

export const reqGetNotifications = async (query: ReqGetNotifications) => {
    const queryStr = getQueryString<ReqGetNotifications>(query)
    return await axios.get<GetQueryReturn<NotificationItem>>(`${BASE_URL_NOTIFICATIONS + queryStr}`)
}

export const reqGetNotification = async (id: string) => {
    return await axios.get<NotificationItem>(`${BASE_URL_NOTIFICATIONS}/${id}`)
}

export const reqUpdateNotification = async (id: string, elements: NotificationItem) => {
    return await axios.put<NotificationItem>(`${BASE_URL_NOTIFICATIONS}/${id}`, { ...elements })
}

// 모든 알람 읽음 표시
export const reqUpdateNotifications = async (userId: string) => {
    return await axios.post(`${BASE_URL_NOTIFICATIONS}:readall`, { fk_user_id: userId })
}

export const reqDeleteNotification = async (id: string) => {
    return await axios.delete(`${BASE_URL_NOTIFICATIONS}/${id}`)
}

// 모든 알람 삭제
export const reqDeleteNotifications = async (userId: string) => {
    return await axios.post(`${BASE_URL_NOTIFICATIONS}:deleteall`, { fk_user_id: userId })
}

export const reqCheckUrl = async(id: string, url: string) => {
    return await axios.post(`${BASE_URL_NOTIFICATIONS}:check-url`, { id, url })
}